import api from "../api/api";
import type IProperty from "../interfaces/IProperty";

export default class PropertyAiGradeApiService {
    public async fetchAiGrade(property: IProperty): Promise<IPropertyAiGrade> {
        const response = await api.post<IPropertyAiGrade>("/propertyAiGrade/fetch", {
            regridIds: property.parcelIds,
        });

        return response.data;
    }
}

export interface IBase64ScreenshotSet {
    mapbox?: string;
    google?: string;
    arcGis?: string;
    bing?: string;
}

export interface IScreenshot {
    source: 'mapbox' | 'google' | 'arcGis' | 'bing';
    base64: string;
}

export interface IPropertyAiGrade {
    grade: string | null;
    usableArea: number | null;
    reasoning: string | null;
    bestScreenshot: IScreenshot;
}
